<p-table 
    #table     
    [value]="prezzi"
    [columns]="colonne" [reorderableColumns]="true"    
    responsiveLayout="stack" 
    [breakpoint]="'960px'"
    styleClass="p-datatable-striped" 
    [paginator]="true" 
    [showCurrentPageReport]="true" 
    [rowHover]="true" 
    showGridlines
    [globalFilterFields]="['settore']" 
    currentPageReportTemplate="{first} di {last} su {totalRecords} prezzi" 
    [rows]="5" [rowsPerPageOptions]="[5, 10, 20, 50]">
    <ng-template pTemplate="caption">
        <div class="flex lg:flex-row flex-col gap-4 w-full">
            <div class="lg:w-3/4 w-full">
                <span class="block w-full p-input-icon-left">
                    <i class="bi bi-search before:align-super before:content-['\f52a']"></i>
                    <input pInputText type="text" (input)="onGlobalFilter(table, $event)" placeholder="Cerca..." class="w-full indent-6" />
                </span>
            </div>
            <div class="lg:w-1/4 w-full">                    
                <button class="w-full h-full btn-outln-backoffice text-center" type="button" (click)="add = true">                
                    <i class="bi bi-plus"></i>
                    Aggiungi prezzo
                </button>
            </div>
        </div>            
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th class="w-1/12"></th>
            <th *ngFor="let col of columns;" class="w-3/12">
                {{col.header}}
            </th>
            <th class="w-2/12"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
        <tr [pReorderableRow]="index">
            <td class="text-center">
                <i class="bi bi-list text-4xl hover:text-black" pReorderableRowHandle></i>
            </td>
            <td *ngFor="let col of columns; let i = index" class="min-w-[15rem]">
               {{col.type == 'moneta' ? (rowData[col.value] != 0 ? (rowData[col.value] | currency: 'EUR') : '-') : (rowData[col.value] | titlecase)}}
            </td>
            <td class="text-center">
                <div class="flex flex-row items-center justify-center">
                    <i class="bi bi-pencil text-2xl hover:text-black cursor-pointer" (click)="onOpenEdit(rowData)"></i>
                    <p-divider layout="vertical"></p-divider>
                    <ng-container *ngIf="rowData.id">
                        <p-confirmPopup #delete>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <p-button class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDeletePrezzo()" label="Elimina" />
                                        <p-button class="text-center btn-outln-backoffice p-2 w-full font-medium" (click)="onAnnullaDeletePrezzo()" label="Annulla" />
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>
                        <i class="bi bi-trash text-2xl hover:text-black cursor-pointer" (click)="onOpenDeletePrezzo($event, rowData, index)"></i>    
                    </ng-container>
                    <ng-container *ngIf="!rowData.id">
                        <i class="bi bi-trash text-2xl hover:text-black cursor-pointer" (click)="prezzi.splice(index, 1)"></i>
                    </ng-container>                    
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="colonne.length + 2">Nessuno prezzo presente.</td>
        </tr>
    </ng-template>
</p-table>

<!-- MODAL ADD/EDIT PREZZI -->
<p-dialog [visible]="(add || edit)" [style]="{width: '50%'}" [header]="add ? 'Aggiungi prezzi' : 'Modifica prezzo'" [modal]="true" class="p-fluid" (visibleChange)="onCloseModal()">
    <ng-template pTemplate="content">

        <form [formGroup]="formPrezzo" (ngSubmit)="add ? onAdd() : onEdit()">
            <div class="flex flex-wrap">                
                <ng-container *ngFor="let colonna of colonne; let i = index">
                    <div class="w-full mb-4">
                        <label>{{colonna.header}}</label>
                        <p-autoComplete [formControlName]="colonna.value" [suggestions]="settori_filtrati" field="settore" appendTo="body"  class="autocomplete w-full" [showEmptyMessage]="false" [dropdown]="true" (completeMethod)="onFilterSettori($event)" *ngIf="colonna.type == 'settore'" />
                        <p-inputNumber [formControlName]="colonna.value" mode="currency" currency="EUR" locale="it-IT" [maxFractionDigits]="2" *ngIf="colonna.type == 'moneta'" />
                    </div>
                </ng-container>
                <div class="w-full flex lg:flex-row flex-col gap-4 justify-end">
                    <button type="submit" class="btn-outln-backoffice p-3 px-8 font-medium" [disabled]="!formPrezzo.valid">{{add ? 'Aggiungi' : 'Modifica'}}</button>
                    <button type="button" class="btn-danger-backoffice p-3 px-8 font-medium" (click)="onCloseModal()">Annulla</button>
                </div>
            </div>
        </form>

    </ng-template>
</p-dialog>
<!-- MODAL ADD/EDIT PREZZI -->